import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { ClubCode } from '@lib/types';

export const isAllowedToOrder = (clubCode: string | undefined, roleType: RoleType | undefined) => {
  const isPrimaryOrAdultAssociate = roleType === RoleType.PRIMARY || roleType === RoleType.ADULT_ASSOCIATE;
  const isTidewaterAssociate = clubCode === ClubCode.TW;

  return isPrimaryOrAdultAssociate || isTidewaterAssociate;
};
